var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'no-ornament': _vm.hudVisible},attrs:{"id":"parchment-footer"}},[_c(_vm.gameHud,{directives:[{name:"show",rawName:"v-show",value:(_vm.hudVisible),expression:"hudVisible"}],ref:"hud",tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }